import React from "react";
import { Typography } from "@/components/common/ui/Typography";
import { cn } from "@/lib/utils/cn";

export interface LabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  required?: boolean;
  className?: string;
}

export function Label({
  htmlFor,
  children,
  required = false,
  className = "",
}: LabelProps) {
  return (
    <Typography
      as="label"
      htmlFor={htmlFor}
      variant="body"
      weight="semibold"
      color="text-navigator-text-primary"
      className={cn("block mb-2", className)}
    >
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </Typography>
  );
}
